export default __webpack_public_path__ + "static/media/cd268f305e5f263560ec73f5f355e3b7.svg";